import { useTheme } from '../../../contexts/ThemeContext';
import { useNavigate } from 'react-router-dom';

interface MenuPanelProps {
  isOpen: boolean;
  onClose: () => void;
  onNewChat: () => void;
}

export default function MenuPanel({ isOpen, onClose, onNewChat }: MenuPanelProps) {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const conversations = [
    /*{ id: 1, title: 'What is Web3?', date: 'Hoy', preview: 'Web3 is a decentralized internet...' },
    { id: 2, title: 'Blockchain basics', date: 'Ayer', preview: 'Blockchain is a distributed ledger...' },
    { id: 3, title: 'NFT explanation', date: '2 días', preview: 'NFTs are unique digital assets...' },
     */
  ];

  const handleViewConversation = (convId: string) => {
    // Navegar a la página de resultados con los datos de la conversación guardada
    navigate('/result', {
      state: {
        projectData: {
          cost: '$5,000 - $8,000',
          time: '4-6 semanas',
          scope: 'Aplicación móvil completa',
          summary: 'Tu proyecto es una aplicación de chat con IA que incluye múltiples temas, progreso de conversación y experiencia de usuario optimizada.',
          details: [
            'Interfaz de usuario moderna y responsive',
            'Sistema de temas claro/oscuro',
            'Integración con IA conversacional',
            'Indicador de progreso por pasos',
            'Animaciones y transiciones suaves',
            'Pantalla de inicio personalizada'
          ]
        },
        fromHistory: true
      }
    });
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300 z-40 ${
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={onClose}
      />

      {/* Panel */}
      <div
        className={`fixed top-0 left-0 h-full w-80 transform transition-transform duration-300 z-50 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } ${
          theme === 'dark'
            ? 'bg-gradient-to-br from-[#0A0118]/95 via-[#1A0B2E]/95 to-[#0A0118]/95 backdrop-blur-xl border-r border-white/10'
            : 'bg-white/95 backdrop-blur-xl border-r border-gray-200 shadow-2xl'
        }`}
      >
        {/* Header */}
        <div className={`flex items-center justify-between p-4 border-b ${
          theme === 'dark' ? 'border-white/10' : 'border-gray-200'
        }`}>
          <h2 className={`text-lg font-semibold ${
            theme === 'dark' ? 'text-white' : 'text-gray-900'
          }`}>Conversations</h2>
          <button
            onClick={onClose}
            className={`w-8 h-8 rounded-full transition-colors flex items-center justify-center ${
              theme === 'dark'
                ? 'bg-white/5 hover:bg-white/10'
                : 'bg-gray-200 hover:bg-gray-300'
            }`}
          >
            <i className={`ri-close-line text-xl ${
              theme === 'dark' ? 'text-white' : 'text-gray-900'
            }`}></i>
          </button>
        </div>

        {/* Content */}
        <div className="p-4 space-y-4 overflow-y-auto h-[calc(100%-73px)]">
          {/* New Chat Button */}
          <button
            onClick={() => {
              onNewChat();
              onClose();
            }}
            className={`w-full flex items-center gap-3 p-3 rounded-xl transition-all ${
              theme === 'dark'
                ? 'bg-gradient-to-r from-purple-500 to-pink-500 hover:shadow-lg hover:shadow-purple-500/50'
                : 'bg-gradient-to-r from-purple-400 to-pink-400 hover:shadow-lg hover:shadow-purple-400/50'
            } text-white`}
          >
            <i className="ri-add-line text-xl"></i>
            <span className="font-medium">New conversation</span>
          </button>

          {/* Chat History */}
          <div className="space-y-2">
            {conversations.map((conv) => (
              <button
                key={conv.id}
                onClick={() => handleViewConversation(conv.id)}
                className={`w-full text-left p-3 rounded-xl transition-all group ${
                  theme === 'dark'
                    ? 'bg-white/5 hover:bg-white/10'
                    : 'bg-gray-50 hover:bg-gray-100'
                }`}
              >
                <div className="flex items-start justify-between mb-1">
                  <h3 className={`font-medium text-sm truncate flex-1 ${
                    theme === 'dark' ? 'text-white' : 'text-gray-900'
                  }`}>
                    {conv.title}
                  </h3>
                  <span className="text-gray-400 text-xs ml-2">{conv.date}</span>
                </div>
                <p className="text-gray-400 text-xs truncate">{conv.preview}</p>
                <div className="flex items-center gap-2 mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className={`text-xs ${
                    theme === 'dark' ? 'text-purple-400' : 'text-purple-600'
                  }`}>
                    <i className="ri-eye-line mr-1"></i>
                    View results
                  </span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
